import { DevelopmentalData } from "@/types/developmental";

export const infantActivities: DevelopmentalData = {
  motor: [
    "Tummy time sessions",
    "Reaching games with toys",
    "Rolling practice activities",
    "Supported sitting practice",
    "Floor play with toys",
  ],
  language: [
    "Reading simple books",
    "Singing songs and lullabies",
    "Talking during daily activities",
    "Making different sounds",
    "Playing peek-a-boo",
  ],
  cognitive: [
    "Black and white pattern cards",
    "Mirror play activities",
    "Showing different objects",
    "Hide and reveal games",
    "Sensory exploration",
  ],
  independent: [
    "Offering safe objects to grasp",
    "Encouraging self-feeding attempts",
    "Providing opportunities for choice",
    "Practice holding bottle",
    "Supervised exploration time",
  ],
  social: [
    "Face-to-face interactions",
    "Gentle interactive games",
    "Family conversation exposure",
    "Responsive caregiving",
    "Varied social experiences",
  ],
};